import logo from "@assets/images/Corvell.jpg";

/**
 * Header configuration
 */
export const headerConfig = {
  logo: {
    src: logo,
    alt: "Corvell Logo",
  },
};
